import { DownloadIcon, MenuItem } from "@hightouch/htui";
import type { AmpLibraryFileFragment } from "src/graphql";
import { canDownloadFile } from "src/pages/projects/library/files/file-download";

/** Renders nothing for a file with no downloadable content, such as a canvas. */
export function DownloadFileMenuItem({
  file,
  onDownload,
}: {
  file: AmpLibraryFileFragment;
  onDownload: (file: AmpLibraryFileFragment) => void;
}) {
  if (!canDownloadFile(file)) return null;
  return (
    <MenuItem icon={DownloadIcon} onClick={() => onDownload(file)}>
      Download file
    </MenuItem>
  );
}
